import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { createApiClient } from './lib/api'
import { AppAuthProvider, useAppAuth } from './lib/auth'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

// API Client Initializer Component
function ApiClientInitializer({ children }: { children: React.ReactNode }) {
  const { getToken } = useAppAuth()

  React.useEffect(() => {
    createApiClient({
      getToken,
    })
  }, [getToken])

  return <>{children}</>
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppAuthProvider>
        <ApiClientInitializer>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ApiClientInitializer>
      </AppAuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)
